<template>
    <div class="table-responsive">
        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Date and time</th>
                    <th>Employer</th>
                    <th>Campaign</th>
                    <th>Job</th>
                    <th>Twilio phone</th>
                    <th>Recruiter phone</th>
                    <th>Call length</th>
                    <th>Type</th>
                    <th>Transferred by JA Agent</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(c, index) in recruiter_calls" :key="index">
                    <td>{{ c.date }}</td>
                    <td>
                        <a :href="url(`admin/employer/${c.employer_id}/detail`)">
                            {{ c.employer_name }}
                        </a>
                    </td>
                    <td>{{ c.campaign_name }}</td>
                    <td>job {{ c.job_id }}</td>
                    <td>{{ c.job_phone_number }}</td>
                    <td>{{ c.employer_number }}</td>
                    <td>
                        {{ c.call_length }}
                        <el-tooltip class="item" effect="dark" content="Charged call" placement="top" style="margin-left: 5px; color: green" v-if="c.is_valid_call">
                            <i class="fas fa-dollar-sign"></i>
                        </el-tooltip>
                    </td>
                    <td>{{ c.call_type }}</td>
                    <td>{{ c.agent_name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
    props: [
        'recruiter_calls',
    ],
}
</script>